
import axios from "axios";
import React from "react";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { loginSliceValue } from "../../redux/reducers/loginSlice";
import { IEditTemplateRes } from "./index.type";

const useEditTemplate = () => {
  const { userDetails } = useSelector(loginSliceValue);
  const [templateLoading, setTemplateLoading] = React.useState(false);

  const getTemplateToEdit = async ({templateId}: { templateId: string }) => {
    setTemplateLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/rtm/template/id/${templateId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userDetails.token,
          },
        }
      );

      if (response?.status === 200) {
        return response.data
      }
    } catch (error) {
      toast.error("Something went wrong while updating status");
    } finally {
      setTemplateLoading(false);
    }
  };

  return { getTemplateToEdit,templateLoading };
};

export default useEditTemplate;
